const state = {
  device: 'desktop',
  homeClassifyShow:false
}

const mutations = {
  TOGGLE_DEVICE: (state, device) => {
    state.device = device
  },
  TOGGLE_HOME_CLASSIFY_SHOW:(state,show)=>{
    state.homeClassifyShow = show
  }
}

const actions = {
  toggleDevice({ commit }, device) {
    commit('TOGGLE_DEVICE', device)
  },
  toggleHomeClassifyShow({ commit,state }){
    commit('TOGGLE_HOME_CLASSIFY_SHOW', !state.homeClassifyShow)
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
